import * as LocalStorage from "~/utilities/localStorage"

// localStorage key for the persisted parking-pay checkout form (cardholder +
// billing address). Card number/CVC are never persisted (they live in the
// Evervault iframe). No secrets are stored here.
const STORAGE_KEY = "winit:parkingPayCheckoutForm"

export const loadCheckoutForm = () => {
  if (typeof window === "undefined") return null
  try {
    return LocalStorage.get(STORAGE_KEY, true)
  } catch (e) {
    return null
  }
}

export const saveCheckoutFormToStorage = (snapshot) => {
  if (typeof window === "undefined") return
  LocalStorage.set(STORAGE_KEY, snapshot)
}
